/**
 * Weergaveschakelaar van de renovatieticketlijst: "Recent" (vlakke lijst,
 * nieuwste eerst) of "Per project" (gegroepeerd per renovatieproject en
 * -onderdeel). De bewaarde keuze zit in `useRenoListViewMode`.
 *
 * @module RenoHelpdesk/Components/RenoViewSwitch
 */

import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';
import type { RenoListViewMode } from '../hooks/useRenoListViewMode';

interface RenoViewSwitchProps {
  value: RenoListViewMode;
  onChange: (mode: RenoListViewMode) => void;
}

export const RenoViewSwitch = ({ value, onChange }: RenoViewSwitchProps) => (
  <Tabs value={value} onValueChange={(next) => onChange(next as RenoListViewMode)}>
    <TabsList>
      <TabsTrigger value="recent">Recent</TabsTrigger>
      <TabsTrigger value="project">Per project</TabsTrigger>
    </TabsList>
  </Tabs>
);
